import { render, staticRenderFns } from "./Notes.vue?vue&type=template&id=d1a02fca&scoped=true"
import script from "./Notes.vue?vue&type=script&lang=js"
export * from "./Notes.vue?vue&type=script&lang=js"
import style0 from "./Notes.vue?vue&type=style&index=0&id=d1a02fca&prod&lang=scss&scoped=true"
import style1 from "./Notes.vue?vue&type=style&index=1&id=d1a02fca&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1a02fca",
  null
  
)

export default component.exports